import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<LicenseDisplay\n  @singleLicense={{this.license}}\n/>",{ moduleName: "cpc-license-manager/pods/license/template.hbs" })